'use strict';
/**
 * !!! DON'T USE THIS UNLESS YOU HAVE GOOD REASON !!!
 * In most circumstances this is a bad idea, however for an embed it's useful; even then it's hacky.
 *
 * data-sw-target-blank-click
 *
 *  makes all a tags target blank on click
 *
 * data-sw-target-blank-click-ignore
 *  any sub elements w/ this attribute will not have their target set to blank
 *
 */
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

var fragemntLoadedEvent = 'sw-fragment-loaded.taragetBlank';
module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-target-blank-click]').each(function() {
    var $this = $(this);

    function makeTargetsBlank() {
      $this.find('a').not('[data-sw-target-blank-click-ignore]').attr('target', '_blank');
    }

    makeTargetsBlank();

    // We want to redo this for every fragment load event
    sw.off(fragemntLoadedEvent);
    sw.on(fragemntLoadedEvent, makeTargetsBlank);
  });
};
